// web/frontend/src/pages/CompanyProfileRoute.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../lib/api';
import CompanyProfile from './CompanyProfile';

export default function CompanyProfileRoute() {
  const { companyName } = useParams();
  const navigate = useNavigate();
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  useEffect(() => {
    const fetchLead = async () => {
      try {
        const response = await api.get(`/api/leads/detail?company_name=${encodeURIComponent(companyName)}`);
        setLead(response.data.lead);
      } catch {
        navigate('/dashboard/history');
      } finally {
        setLoading(false);
      }
    };
    fetchLead();
  }, [companyName, navigate]);

  if (loading) {
    return (
      <div className="page-content" style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
        <div className="loader"></div>
      </div>
    );
  }

  if (!lead) return null;

  return <CompanyProfile lead={lead} onBack={() => navigate('/dashboard/history')} />;
}